function PixelDensity() {
    const pixelDensity = Math.floor(window.devicePixelRatio);
    return (
        <div className="information_card">
            <h3>Pixel density</h3>
            <p className="information" data-pixel-density={pixelDensity}>{pixelDensity}</p>
        </div>
    );
}

export default PixelDensity;